import script from "./SolicitudUsuario.vue?vue&type=script&setup=true&lang=js"
export * from "./SolicitudUsuario.vue?vue&type=script&setup=true&lang=js"

import "./SolicitudUsuario.vue?vue&type=style&index=0&id=48d652ed&scoped=true&lang=css"
import "./SolicitudUsuario.vue?vue&type=style&index=1&id=48d652ed&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48d652ed"]])

export default __exports__